<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">Local-System Acct Mapping</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">

  <!-- Loader -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- Content (after loading) -->
  @if (!showFormLoader) {
<div>

    <!-- Tab Navigation (at TOP, outside divShadow) -->
    <ul class="nav nav-pills" style="margin-bottom: 15px;">
      <li [class.active]="activeTab === 'mapping'">
        <a (click)="activeTab = 'mapping'" style="cursor: pointer;">Local-System Acct Mapping</a>
      </li>
      <li [class.active]="activeTab === 'audit'">
        <a (click)="activeTab = 'audit'; loadAuditData()" style="cursor: pointer;">Audit</a>
      </li>
    </ul>

    <!-- ==================== MAPPING TAB ==================== -->
    @if (activeTab === 'mapping') {
<div>
      <div class="divShadow">
        <form class="form-horizontal" novalidate>
          <div class="form-content">

        <!-- Account Info Row - ALL 4 FIELDS IN ONE LINE -->
        <div class="row account-info-row">
          <div class="field-group" style="width: 12%;">
            <label>Acct Type:</label>
            <input type="text" class="form-control input-sm" [value]="chartAcctData.acct_type" readonly>
          </div>

          <div class="field-group" style="width: 15%;">
            <label>Local Chart:</label>
            <input type="text" class="form-control input-sm" [value]="chartAcctData.local_chart" readonly>
          </div>

          <div class="field-group" style="width: 35%;">
            <label>Local Account:</label>
            <textarea class="form-control input-sm" rows="3" readonly>{{chartAcctData.localaccts}}</textarea>
          </div>

          @if (!sysAcctHide) {
<div class="field-group" style="width: 35%;">
            <label>Tax Sensitive/System Account</label>
            @if (loadingSysAcct) {
<div class="loading-spinner">
              <i class="fa fa-spinner fa-spin" style="color: #e12827;"></i>
            </div>
}
            @if (!loadingSysAcct) {
<select gtwSearchableSelect
                    class="form-control input-sm"
                    [(ngModel)]="sysAcctSelected"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onSystemAcctChange()">
              <option value="Please select System Account">Please select System Account</option>
              @for (sysAcct of sysAccDropdownData; track $index) {
<option [value]="sysAcct">{{sysAcct}}</option>
}
            </select>
}
          </div>
}
        </div>

        <!-- Lookup Panel -->
        <div class="panel panel-default">
          <div class="panel-heading">
            <span>Lookup for System Acct to Form Line Mapping</span>
            <div class="panel-actions">
              <button type="button" class="btn btn-success btn-xs" (click)="toggleLookup()">Lookup</button>
              <i class="fa"
                 [ngClass]="{'fa-chevron-down': lookUpMapping, 'fa-chevron-up': !lookUpMapping}"
                 style="cursor: pointer; margin-left: 10px;"
                 (click)="toggleLookup()"></i>
            </div>
          </div>

          @if (lookUpMapping) {
<div class="panel-body">
            <!-- ALL 7 LOOKUP FIELDS IN ONE ROW -->
            <div class="lookup-row-inline">
              <div class="lookup-field" style="width: 13%;">
                <label>IRS Form</label>
                <select gtwSearchableSelect class="form-control input-sm"
                        [(ngModel)]="CHECK_FORM"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="getLookupNext(1, 'SCHEDULE', CHECK_FORM); formChanged()">
                  <option value="">Select...</option>
                  @for (form of lookupForm; track $index) {
<option [value]="form">{{form}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 13%;">
                <label>Schedule</label>
                <select gtwSearchableSelect class="form-control input-sm"
                        [(ngModel)]="CHECK_SCHEDULE"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_FORM"
                        (ngModelChange)="getLookupNext(2, 'FORM_SECTION_NAME', CHECK_SCHEDULE); scheduleChanged()">
                  <option value="">Select...</option>
                  @for (schedule of lookupSchedule; track $index) {
<option [value]="schedule">{{schedule}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 13%;">
                <label>Section</label>
                <select gtwSearchableSelect class="form-control input-sm"
                        [(ngModel)]="CHECK_SECTION"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_SCHEDULE"
                        (ngModelChange)="getLookupNext(3, 'FORM_PART_NO', CHECK_SECTION); sectionChanged()">
                  <option value="">Select...</option>
                  @for (section of lookupSection; track $index) {
<option [value]="section">{{section}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 13%;">
                <label>Part</label>
                <select gtwSearchableSelect class="form-control input-sm"
                        [(ngModel)]="CHECK_PART"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_SECTION"
                        (ngModelChange)="getLookupNext(4, 'LINE', CHECK_PART); partChanged()">
                  <option value="">Select...</option>
                  @for (part of lookupPart; track $index) {
<option [value]="part">{{part}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 15%;">
                <label>Line</label>
                <select gtwSearchableSelect class="form-control input-sm"
                        [(ngModel)]="CHECK_LINE"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_PART"
                        (ngModelChange)="getLookupNext(5, 'COL', CHECK_LINE); lineChanged()">
                  <option value="">Select...</option>
                  @for (line of lookupLine; track $index) {
<option [value]="line">{{line}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 8%;">
                <label>Column</label>
                <select gtwSearchableSelect class="form-control input-sm"
                        [(ngModel)]="CHECK_COL"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_LINE"
                        (ngModelChange)="getLookupNext(6, 'SYS_ACCT', CHECK_COL); columnChanged()">
                  <option value="">Select...</option>
                  @for (col of lookupColumn; track $index) {
<option [value]="col">{{col}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 20%;">
                <label>Mapped System Accounts</label>
                <select gtwSearchableSelect class="form-control input-sm"
                        [(ngModel)]="CHECK_SYS_MAP_ACCT"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_COL">
                  <option value="">Select...</option>
                  @for (acct of lookupSysMapAcct; track $index) {
<option [value]="acct">{{acct}}</option>
}
                </select>
              </div>
            </div>

            <div class="lookup-actions">
              <button type="button" class="btn btn-success btn-xs" (click)="applyChanges()">Apply Changes</button>
              <button type="button" class="btn btn-danger btn-xs" (click)="resetLookup()">Reset Changes</button>
            </div>
          </div>
}
        </div>

        <!-- Tax Sensitive Panel -->
        @if (loadSystemTaxsensitivitydata.length > 1) {
<div class="panel panel-default">
          <div class="panel-heading">
            <span>TaxSensitive</span>
            <div class="panel-actions">
              <button type="button" class="btn btn-success btn-xs" (click)="taxSensitiveToggleLookup()">TaxSensitive</button>
              <i class="fa"
                 [ngClass]="{'fa-chevron-down': taxSensitiveLookUpArrow, 'fa-chevron-up': !taxSensitiveLookUpArrow}"
                 style="cursor: pointer; margin-left: 10px;"
                 (click)="taxSensitiveToggleLookup()"></i>
            </div>
          </div>

          @if (taxSensitiveLookUpArrow) {
<div class="panel-body">
            @if (loadingTaxSensLookup) {
<div class="loading-spinner">
              <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
            </div>
}

            @if (!loadingTaxSensLookup && loadSystemTaxsensitivitydata.length > 0) {
<div class="tax-sensitive-wrapper">
              <div class="table-responsive">
                <table class="table table-hover table-bordered table-striped table-condensed custom-table" style="table-layout: fixed; min-width: 900px;">
                <thead>
                  <tr class="tax-sensitive-header">
                    <th style="width: 4%;" class="text-center">Action</th>
                    <th style="width: 12%;" class="sortable" (click)="sortByTax('1', sort_key_tax['1'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['1']===0, 'fa-sort-asc': sort_key_tax['1']===1, 'fa-sort-desc': sort_key_tax['1']===2}"></i>
                      TEMPLATE
                    </th>
                    <th style="width: 12%;" class="sortable" (click)="sortByTax('2', sort_key_tax['2'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['2']===0, 'fa-sort-asc': sort_key_tax['2']===1, 'fa-sort-desc': sort_key_tax['2']===2}"></i>
                      USER DESC
                    </th>
                    <th style="width: 10%;" class="sortable" (click)="sortByTax('3', sort_key_tax['3'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['3']===0, 'fa-sort-asc': sort_key_tax['3']===1, 'fa-sort-desc': sort_key_tax['3']===2}"></i>
                      SCHDM TYPE
                    </th>
                    <th style="width: 10%;" class="sortable" (click)="sortByTax('4', sort_key_tax['4'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['4']===0, 'fa-sort-asc': sort_key_tax['4']===1, 'fa-sort-desc': sort_key_tax['4']===2}"></i>
                      METHOD CALC
                    </th>
                    <th style="width: 7%;" class="sortable" (click)="sortByTax('5', sort_key_tax['5'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['5']===0, 'fa-sort-asc': sort_key_tax['5']===1, 'fa-sort-desc': sort_key_tax['5']===2}"></i>
                      MULTIPLIER
                    </th>
                    <th style="width: 12%;" class="sortable" (click)="sortByTax('6', sort_key_tax['6'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['6']===0, 'fa-sort-asc': sort_key_tax['6']===1, 'fa-sort-desc': sort_key_tax['6']===2}"></i>
                      POSTING TAC
                    </th>
                    <th style="width: 12%;" class="sortable" (click)="sortByTax('7', sort_key_tax['7'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['7']===0, 'fa-sort-asc': sort_key_tax['7']===1, 'fa-sort-desc': sort_key_tax['7']===2}"></i>
                      POSTING ACCT
                    </th>
                    <th style="width: 12%;" class="sortable" (click)="sortByTax('8', sort_key_tax['8'])">
                      <i class="fa" [ngClass]="{'fa-sort': sort_key_tax['8']===0, 'fa-sort-asc': sort_key_tax['8']===1, 'fa-sort-desc': sort_key_tax['8']===2}"></i>
                      TBBS ACCT
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (taxSensitive of sortedRows; track $index) {
<tr>
                    <td class="text-center">
                      <i class="fa fa-edit pointer" style="margin-right: 5px;" (click)="formEdit(taxSensitive)"></i>
                      @if (taxSensitive.SCHDM_TEMPLATE != ' - ') {
<i class="fa fa-trash pointer"
                        
                         (click)="formDelete(taxSensitive)"></i>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable) {
<gtw-custom-select-local-system
                              [options]="templocalaccount"
                              [displayKey]="''"
                              [(ngModel)]="taxSensitive.dropdowndata"
                              [ngModelOptions]="{standalone: true}"
                              (optionSelected)="changeTemplate(taxSensitive, $event)"
                              [placeholder]="'Select Template...'"
                      ></gtw-custom-select-local-system>
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.SCHDM_TEMPLATE_DEFAULT || (taxSensitive.SCHDM_TEMPLATE !== '----------PREFERRED---------' && taxSensitive.SCHDM_TEMPLATE !== '-------NON PREFERRED-------' ? taxSensitive.SCHDM_TEMPLATE : '')}}</span>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable) {
<input type="text" class="form-control input-sm"
                             [ngModel]="taxSensitive.USER_DESC"
                             [ngModelOptions]="{standalone: true}"
                             (ngModelChange)="taxSensitive.USER_DESC = $event">
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.USER_DESC === '----------PREFERRED---------' || taxSensitive.USER_DESC === '-------NON PREFERRED-------' ? '' : taxSensitive.USER_DESC}}</span>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable && taxSensitive.schdmtypedropdown?.length) {
<gtw-custom-select-local-system
                              [options]="taxSensitive.schdmtypedropdown"
                              [displayKey]="''"
                              [(ngModel)]="taxSensitive.SCHDM_TYPE_DEFAULT"
                              [ngModelOptions]="{standalone: true}"
                              (optionSelected)="schdmTypeChange(taxSensitive, $event)"
                              [placeholder]="'Select Type...'"
                      ></gtw-custom-select-local-system>
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.SCHDM_TYPE_DEFAULT}}</span>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable && taxSensitive.methodofcaldropdown?.length) {
<gtw-custom-select-local-system
                              [options]="taxSensitive.methodofcaldropdown"
                              [displayKey]="''"
                              [(ngModel)]="taxSensitive.METHOD_OF_CALC_DEFAULT"
                              [ngModelOptions]="{standalone: true}"
                              (optionSelected)="methodOfCalcChange(taxSensitive, $event)"
                              [placeholder]="'Select Method...'"
                      ></gtw-custom-select-local-system>
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.METHOD_OF_CALC_DEFAULT}}</span>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable) {
<input type="text" class="form-control input-sm"
                             [(ngModel)]="taxSensitive.MULTIPLIER"
                             [ngModelOptions]="{standalone: true}">
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.MULTIPLIER}}</span>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable && taxSensitive.postingtacdropdown?.length) {
<gtw-custom-select-local-system
                              [options]="taxSensitive.postingtacdropdown"
                              [displayKey]="''"
                              [(ngModel)]="taxSensitive.POSTING_TAC_DEFAULT"
                              [ngModelOptions]="{standalone: true}"
                              (optionSelected)="postingTacChange(taxSensitive, $event)"
                              [placeholder]="'Select Posting TAC...'"
                      ></gtw-custom-select-local-system>
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.POSTING_TAC_DEFAULT}}</span>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable && taxSensitive.postingacctdropdown?.length) {
<gtw-custom-select-local-system
                              [options]="taxSensitive.postingacctdropdown"
                              [displayKey]="''"
                              [(ngModel)]="taxSensitive.POSTING_ACCT_DEFAULT"
                              [ngModelOptions]="{standalone: true}"
                              (optionSelected)="postingAcctChange(taxSensitive, $event)"
                              [placeholder]="'Select Posting Acct...'"
                      ></gtw-custom-select-local-system>
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.POSTING_ACCT_DEFAULT}}</span>
}
                    </td>
                    <td>
                      @if (taxSensitive.isEditable && taxSensitive.tbbsacctdropdown?.length) {
<gtw-custom-select-local-system
                              [options]="taxSensitive.tbbsacctdropdown"
                              [displayKey]="''"
                              [(ngModel)]="taxSensitive.TAX_STREAM_ACCT_DEFAULT"
                              [ngModelOptions]="{standalone: true}"
                              (optionSelected)="tbbsAcctChange(taxSensitive, $event)"
                              [placeholder]="'Select TBBS Acct...'"
                      ></gtw-custom-select-local-system>
}
                      @if (!taxSensitive.isEditable) {
<span>{{taxSensitive.TAX_STREAM_ACCT_DEFAULT}}</span>
}
                    </td>
                  </tr>
}
                </tbody>
              </table>

              </div>

              <div class="text-center" style="margin-top: 10px;">
                <button type="button" class="btn btn-danger btn-xs" (click)="resetTaxSensLookup()">Reset Changes</button>
              </div>
            </div>
}

            @if (!loadingTaxSensLookup && loadSystemTaxsensitivitydata.length === 0) {
<div class="no-data-message">
              No tax sensitive data available.
            </div>
}
          </div>
}
        </div>
}

        <!-- IRS Form Table (rendered inside the mapping body, above the footer buttons) -->
        @if (irsFormData && irsFormData.length > 0) {
<div class="irs-form-section">
          <table class="table table-hover table-bordered table-striped table-condensed irs-form-table">
            <thead>
              <tr class="irs-form-header">
                <th class="sortable" (click)="sortBy('1', sort_key['1'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['1'] === 0,
                    'fa-sort-asc': sort_key['1'] === 1,
                    'fa-sort-desc': sort_key['1'] === 2
                  }"></i> IRS Form
                </th>
                <th class="sortable" (click)="sortBy('2', sort_key['2'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['2'] === 0,
                    'fa-sort-asc': sort_key['2'] === 1,
                    'fa-sort-desc': sort_key['2'] === 2
                  }"></i> Schedule
                </th>
                <th class="sortable" (click)="sortBy('3', sort_key['3'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['3'] === 0,
                    'fa-sort-asc': sort_key['3'] === 1,
                    'fa-sort-desc': sort_key['3'] === 2
                  }"></i> Section
                </th>
                <th class="sortable" (click)="sortBy('4', sort_key['4'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['4'] === 0,
                    'fa-sort-asc': sort_key['4'] === 1,
                    'fa-sort-desc': sort_key['4'] === 2
                  }"></i> Part
                </th>
                <th class="sortable" (click)="sortBy('5', sort_key['5'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['5'] === 0,
                    'fa-sort-asc': sort_key['5'] === 1,
                    'fa-sort-desc': sort_key['5'] === 2
                  }"></i> Line No.
                </th>
                <th class="sortable" (click)="sortBy('6', sort_key['6'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['6'] === 0,
                    'fa-sort-asc': sort_key['6'] === 1,
                    'fa-sort-desc': sort_key['6'] === 2
                  }"></i> Line Description.
                </th>
                <th class="sortable" (click)="sortBy('7', sort_key['7'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['7'] === 0,
                    'fa-sort-asc': sort_key['7'] === 1,
                    'fa-sort-desc': sort_key['7'] === 2
                  }"></i> Column
                </th>
              </tr>
            </thead>
            <tbody>
              @for (irsData of irsFormData; track $index) {
<tr>
                <td>{{irsData.FORM}}</td>
                <td>{{irsData.SCHEDULE}}</td>
                <td>{{irsData.SECTION_NAME}}</td>
                <td>{{irsData.PART_NO}}</td>
                <td>{{irsData.LINE}}</td>
                <td>{{irsData.LINE_DESC}}</td>
                <td>{{irsData.COL}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
}

        <!-- Modal Footer INSIDE the form -->
        <div class="modal-footer-inner">
          <button class="btn btn-info btn-sm"
                  type="button"
                  [disabled]="isSaveClicked"
                  (click)="save()">
            @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
          </button>

          <button class="btn btn-danger-outline btn-sm"
                  type="button"
                  (click)="reset()">Reset</button>

          <button class="btn btn-warning btn-sm"
                  type="button"
                  (click)="cancel()">Cancel</button>
        </div>

          </div><!-- /form-content -->
        </form>
      </div><!-- /divShadow -->
    </div>
}<!-- /MAPPING TAB -->

    <!-- ==================== AUDIT TAB ==================== -->
    @if (activeTab === 'audit') {
<div>
      @if (loadingAudit) {
<div class="loading-spinner">
        <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
      </div>
}

      @if (!loadingAudit && auditData.length > 0) {
<div class="table-responsive">
        <table class="table table-hover table-bordered table-striped table-condensed audit-table" style="table-layout: fixed;">
          <thead>
            <tr class="audit-header">
              <th style="width: 15%;" class="sortable" (click)="sortByAudit('1', sort_key_audit['1'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['1']===0, 'fa-sort-asc': sort_key_audit['1']===1, 'fa-sort-desc': sort_key_audit['1']===2}"></i> UPDATED_ON
              </th>
              <th style="width: 12%;" class="sortable" (click)="sortByAudit('2', sort_key_audit['2'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['2']===0, 'fa-sort-asc': sort_key_audit['2']===1, 'fa-sort-desc': sort_key_audit['2']===2}"></i> LOCAL_CHART
              </th>
              <th style="width: 12%;" class="sortable" (click)="sortByAudit('3', sort_key_audit['3'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['3']===0, 'fa-sort-asc': sort_key_audit['3']===1, 'fa-sort-desc': sort_key_audit['3']===2}"></i> SYSTEM_CHART
              </th>
              <th style="width: 12%;" class="sortable" (click)="sortByAudit('4', sort_key_audit['4'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['4']===0, 'fa-sort-asc': sort_key_audit['4']===1, 'fa-sort-desc': sort_key_audit['4']===2}"></i> LOCAL_ACCT
              </th>
              <th style="width: 12%;" class="sortable" (click)="sortByAudit('5', sort_key_audit['5'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['5']===0, 'fa-sort-asc': sort_key_audit['5']===1, 'fa-sort-desc': sort_key_audit['5']===2}"></i> SYSTEM_ACCT
              </th>
              <th style="width: 10%;" class="sortable" (click)="sortByAudit('6', sort_key_audit['6'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['6']===0, 'fa-sort-asc': sort_key_audit['6']===1, 'fa-sort-desc': sort_key_audit['6']===2}"></i> DML_TYPE
              </th>
              <th style="width: 12%;" class="sortable" (click)="sortByAudit('7', sort_key_audit['7'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['7']===0, 'fa-sort-asc': sort_key_audit['7']===1, 'fa-sort-desc': sort_key_audit['7']===2}"></i> OLD_NEW_FLAG
              </th>
              <th style="width: 15%;" class="sortable" (click)="sortByAudit('8', sort_key_audit['8'])">
                <i class="fa" [ngClass]="{'fa-sort': sort_key_audit['8']===0, 'fa-sort-asc': sort_key_audit['8']===1, 'fa-sort-desc': sort_key_audit['8']===2}"></i> UPDATED_BY
              </th>
            </tr>
          </thead>
          <tbody>
            @for (audit of auditData; track $index) {
<tr>
              <td>{{audit.UPDATED_ON}}</td>
              <td>{{audit.LOCAL_CHART}}</td>
              <td>{{audit.SYSTEM_CHART}}</td>
              <td>{{audit.LOCAL_ACCT}}</td>
              <td>{{audit.SYSTEM_ACCT}}</td>
              <td>{{audit.DML_TYPE}}</td>
              <td>{{audit.OLD_NEW_FLAG}}</td>
              <td>{{audit.UPDATED_BY}}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
}

      @if (!loadingAudit && auditData.length === 0) {
<div class="no-data-message">
        No audit data available.
      </div>
}
    </div>
}<!-- /AUDIT TAB -->

  </div>
}<!-- /!showFormLoader wrapper -->
</div>

